// extracted by mini-css-extract-plugin
module.exports = {"disabled":"_2JO-a","stretchToContainer":"_3NhSj"};